import React from "react";
import Layout from "./components/Layout";

const Merch = () => {
  return (
    <Layout>
      <div className="bg-[#f20404] min-h-screen">
        <div className="flex flex-col md:flex-row justify-between">
          <img src={"catFlyer.png"} alt={"menu2"} className="w-full h-auto " />
        </div>
      </div>
    </Layout>
  );
};

export default Merch;
